module.exports = __webpack_public_path__ + "static/img/Awer-Mabil.01ee8bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Awer-Mabil.jpg
// module id = +f1o
// module chunks = 0